import { createElement } from 'react';

const SvgOptions = (props) => (createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 8 32", fill: "none" }, props),
    createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 25.077a2.923 2.923 0 100 5.846 2.923 2.923 0 000-5.846zM0 28a4 4 0 118 0 4 4 0 01-8 0zM4 13.077a2.923 2.923 0 100 5.846 2.923 2.923 0 000-5.846zM0 16a4 4 0 118 0 4 4 0 01-8 0zM4 1.077a2.923 2.923 0 100 5.846 2.923 2.923 0 000-5.846zM0 4a4 4 0 118 0 4 4 0 01-8 0z", fill: "currentColor" })));

export default SvgOptions;
